import { Grid } from '@/atoms';
import { CardBlog } from '@/molecules';

import type { FunctionComponent } from 'react';
import type { TypeBlogProps } from './types';

/**
 * Blog
 */
export const Blog: FunctionComponent<TypeBlogProps> = ({
  className = '',
  cardBelow,
  cardAbove,
  cardLeft,
}: TypeBlogProps) => (
  <Grid className={`!gap-12 md:!gap-8 ${className}`} lg={2}>
    {Object.keys(cardLeft ?? {}).length > 0 && cardLeft && (
      <Grid.Item rowSpanXS={2} className="flex items-start justify-start">
        <CardBlog
          date={cardLeft.date}
          image={cardLeft.image}
          slug={cardLeft.slug}
          title={cardLeft.title}
          {...(cardLeft?.description && {
            description: cardLeft?.description,
          })}
        />
      </Grid.Item>
    )}
    {Object.keys(cardAbove ?? {}).length > 0 && cardAbove && (
      <Grid.Item>
        <CardBlog
          date={cardAbove.date}
          image={cardAbove.image}
          slug={cardAbove.slug}
          title={cardAbove.title}
          {...(cardAbove?.description && {
            description: cardAbove?.description,
          })}
        />
      </Grid.Item>
    )}
    {Object.keys(cardBelow ?? {}).length > 0 && cardBelow && (
      <Grid.Item>
        <CardBlog
          date={cardBelow.date}
          image={cardBelow.image}
          slug={cardBelow.slug}
          title={cardBelow.title}
          {...(cardBelow?.description && {
            description: cardBelow?.description,
          })}
        />
      </Grid.Item>
    )}
  </Grid>
);

Blog.displayName = 'Blog';
